// 引用api文件
import api from '../index';
/**
 * @author yangluyao
 * @date 2020-03-10
 * @Description: 统计部分
*/
//  检查对象的统计
export function checkObjStatis(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/statisDept/getStatisDeptCheckTypeLinkTypeAndMchNum', data, success, failure, menuId); }
 // 检查对象的导出
export function exportCheckObjStatis(data, success, failure, menuId) { return api.getBlob('hzf-admin/sys/statisDept/getStatisDeptCheckTypeLinkTypeAndMchNumToExcel', data, success, failure, menuId); }
// 根据检查类别获取统计的产品数
export function productStatisByCheckType(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/StatisInspectCheck/getStatisProductCheckNumByCheckTypeAndDepts', data, success, failure, menuId); }

// 用户统计执法记录数量
export function usersLawNumStatis(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/statisUser/getStaticUserInspectByUserIdOrDeptId', data, success, failure, menuId); }
// 用户执法统计导出
export function exportUserGroupStatis(data, success, failure, menuId) { return api.getBlob('hzf-admin/sys/statisUser/getStaticUserInspectByUserIdOrDeptIdToExcel', data, success, failure, menuId); }

// 任务耗时统计
export function timeConsumingStatis(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/inspectTask/getInspectTaskSpendTime', data, success, failure, menuId); }
// 任务耗时导出
export function exportTimeConsumingStatis(data, success, failure, menuId) { return api.getBlob('hzf-admin/sys/inspectTask/getInspectTaskSpendTimeToExcel', data, success, failure, menuId); }
// 已完成任务导出
export function exportTaskCompleteStatis(data, success, failure, menuId) { return api.getBlob('hzf-admin/sys/inspectTask/getcheckoverInfoToExcel', data, success, failure, menuId); }
// 已完成任务统计
export function taskCompleteStatis(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/inspectTask/getcheckoverInfo', data, success, failure, menuId); }
//部门检查任务统计导出
export function exportDeptStatis(data, success, failure, menuId) { return api.getBlob('hzf-admin/sys/statisDept/staticDeptOutExcle', data, success, failure, menuId); }
//部门检查任务统计
export function deptStatis(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/statisDept/staticDept', data, success, failure, menuId); }
//产品检查任务统计
export function productCheckStatis(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/StatisInspectCheck/getStatisProductCheckByDeptAndTimes', data, success, failure, menuId); }
//热力图
export function hitMapStatis(data, success, failure, menuId) { return api.postFormData('hzf-admin/sys/StatisInspectCheck/getstatisProductPrombleNumAndAddress', data, success, failure, menuId); }

// 简报获取任务一块的详情
export function getTaskBriefInfo(data, success, failure, menuId) { return api.postFormData('hzf-admin/simpleReport/inspectBaseInfoReport/getInfo', data, success, failure, menuId); }


